import { InterfaceActions, Constants } from '@leverege/api-redux';
import { RoutesUtil } from '@leverege/molten/routes';
import { Plugins } from '@leverege/plugin';
export default class OpenApiApi {
  constructor({
    relationship,
    match
  }) {
    this.relationship = relationship;
    this.match = match;
    this.api = Plugins.get('OpenApi', plg => plg.name === relationship.apiName)[0];
    this.comms = this.api.comms;
    this.path = RoutesUtil.resolve(this.relationship.urlPath, this.match);
    this.parentPath = this.relationship.parent && RoutesUtil.resolve(this.relationship.parent.urlPath, this.match);
    this.apiBasePath = this.api.basePath?.slice(1) || '';
    this.childComms = this.comms.child(`${this.apiBasePath}${this.path}`);
    this.limitKey = this.relationship.options.limitKey;
    this.offsetKey = this.relationship.options.offsetKey;
    this.itemsKey = this.relationship.options.itemsKey;
    this.totalKey = this.relationship.options.totalKey;
    this.sortKey = this.relationship.options.sortKey;
    this.filterKey = this.relationship.options.filterKey;
    this.filterFormat = this.api.options?.filterFormat;
    this.nComms = {
      get: async (...args) => {
        const res = await this.comms.get(...args);
        const {
          [this.limitKey]: limit,
          [this.offsetKey]: offset,
          [this.itemsKey]: items,
          [this.totalKey]: total,
          [this.sortKey]: sort,
          [this.filterKey]: filter,
          ...rest
        } = res;
        return {
          ...rest,
          perPage: limit,
          startIndex: offset,
          total,
          items,
          sort,
          filter
        };
      },
      post: async (...args) => {
        return this.comms.post(...args);
      },
      put: async (...args) => {
        return this.comms.put(...args);
      },
      patch: async (...args) => {
        return this.comms.patch(...args);
      },
      delete: async (...args) => {
        const res = await this.comms.delete(...args);
        return {
          ...res,
          type: 'deviceRemoved'
        };
      }
    };
  }
  list(opts, extra) {
    const {
      limit,
      offset,
      sort,
      filter,
      ...rest
    } = opts ?? {};
    return InterfaceActions.list(this.path, null, Constants.INTERFACE_LIST, {
      ...rest,
      [this.limitKey]: limit,
      [this.offsetKey]: offset,
      [this.sortKey]: sort,
      [this.filterKey]: filter
    }, extra?.queryName, {
      api: this.nComms,
      basePath: this.apiBasePath
    });
  }
  get(opts, extra) {
    return InterfaceActions.list(this.path, null, Constants.INTERFACE_GET, opts, extra?.queryName, {
      api: this.nComms,
      basePath: this.apiBasePath
    });
  }
  create(body, opts, extra) {
    return InterfaceActions.create(this.path, body, null, Constants.INTERFACE_GET, opts, {
      api: this.nComms,
      basePath: this.apiBasePath
    });
  }
  update(body, opts, extra) {
    return InterfaceActions.update(this.path, body, null, null, Constants.INTERFACE_UPDATE, opts, {
      api: this.nComms,
      basePath: this.apiBasePath
    });
  }
  delete(body, opts, extra) {
    return InterfaceActions.remove(this.parentPath, this.relationship.id, body, opts, null, {
      api: this.nComms,
      basePath: this.apiBasePath
    });
  }
  canList(opts) {
    return InterfaceActions.canList(this.path, opts, {
      api: this.nComms,
      basePath: this.apiBasePath
    });
  }
  canGet(opts) {
    return InterfaceActions.canGet(this.path, opts, {
      api: this.nComms,
      basePath: this.apiBasePath
    });
  }
  canCreate(body, opts) {
    return InterfaceActions.canCreate(this.path, opts, body, {
      api: this.nComms,
      basePath: this.apiBasePath
    });
  }
  canUpdate(body, opts) {
    return InterfaceActions.canUpdate(this.path, opts, body, {
      api: this.nComms,
      basePath: this.apiBasePath
    });
  }
  canDelete(body, opts) {
    return InterfaceActions.canDelete(this.path, opts, body, {
      api: this.nComms,
      basePath: this.apiBasePath
    });
  }
  canAction(body, query, getPath, method, action) {
    return InterfaceActions.interfaceCan(getPath(this.path), this.path, method, action, {
      query,
      body
    }, {
      override: {
        api: this.nComms,
        basePath: this.apiBasePath
      }
    });
  }
}